// extracted by mini-css-extract-plugin
export default {"handle":"SidebarResizeHandle_handle__NlDU-","dragging":"SidebarResizeHandle_dragging__6lan-"};